import { createSlice } from "@reduxjs/toolkit";

const TOKEN_KEY = "admin_token";
const USER_KEY = "admin_user";

function loadFromStorage() {
  try {
    return {
      token: localStorage.getItem(TOKEN_KEY) || null,
      user: JSON.parse(localStorage.getItem(USER_KEY)) || null,
    };
  } catch {
    return { token: null, user: null };
  }
}

const authSlice = createSlice({
  name: "auth",
  initialState: loadFromStorage(),
  reducers: {
    setCredentials(state, action) {
      const { token, user } = action.payload;
      state.token = token;
      state.user = user;
      localStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    clearCredentials(state) {
      state.token = null;
      state.user = null;
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
